export class Pagination {
  constructor(
    public page = 0,
    public offset = 0,
    public totalPages = 0,
    public totalItems = 0,
    public count = 0, // the total count of the elements that are available
  ) {}
}
